/*
 * -----------------------------------------------------------------------
 *  <copyright file="radio-button/index.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import './styles.scss';
import { RadioButton } from '@progress/kendo-react-inputs';

interface RadioButtonInterface {
    checked: boolean;
    onChange(e: any): void;
}

const RedesignedRadioButton = ({ checked, onChange }: RadioButtonInterface) => (
    <div className="custom-radio-button">
        <RadioButton checked={checked} onChange={onChange} />
    </div>
);

export default RedesignedRadioButton;
